import { Action, Reducer } from "redux";
import { PreQuoteTypeState, PreQuoteTypeTypes, PreQuoteTypeActionTypes } from "./preQuoteTypeTypes";

export const INITIAL_STATE: PreQuoteTypeState = {
	preQuoteType: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const preQuoteTypeReducer: Reducer<PreQuoteTypeState> = (state: PreQuoteTypeState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as PreQuoteTypeActionTypes;
	switch (actionTypes.type) {
		case PreQuoteTypeTypes.GET_PRE_QUOTE_TYPE:
			return {
				...state,
				preQuoteType: { ...state.preQuoteType, isLoading: true },
			};
		case PreQuoteTypeTypes.SAVE_PRE_QUOTE_TYPE:
			return {
				...state,
				preQuoteType: {
					...state.preQuoteType,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case PreQuoteTypeTypes.RESET_REDUCER_PRE_QUOTE_TYPE:
			return {
				...state,
				preQuoteType: INITIAL_STATE.preQuoteType,
			};
		default:
			return state;
	}
};

export default preQuoteTypeReducer;
